import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { slugifyCustomFieldKey } from "@/lib/partner-api";

export type CustomFieldRow = { id: string; key: string; value: string };

export function PartnerApiCurlCustomFields({
  rows,
  onChange,
}: {
  rows: CustomFieldRow[];
  onChange: (rows: CustomFieldRow[]) => void;
}) {
  const addRow = () => {
    onChange([...rows, { id: crypto.randomUUID(), key: "", value: "" }]);
  };

  return (
    <div className="sm:col-span-2 space-y-2">
      <div className="flex items-center justify-between gap-2">
        <Label>Campos deste lead</Label>
        <Button type="button" size="sm" variant="outline" onClick={addRow}>
          <Plus className="h-3.5 w-3.5 mr-1.5" />
          Adicionar
        </Button>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">
        Campos extras só deste lead — por exemplo, de onde o contato veio (<span className="font-mono text-[12px] text-foreground">utm_source</span> ={" "}
        <span className="font-mono text-[12px] text-foreground">google</span>), placa do veículo, código do imóvel ou qualquer dado do seu formulário.
        Você inventa a chave; ela vai em <span className="font-mono text-[12px] text-foreground">custom_fields</span> no POST e volta igual no GET.
        Não precisa cadastrar antes e nenhum campo é obrigatório.
      </p>

      {rows.length === 0 && (
        <p className="text-sm text-muted-foreground italic">
          Nenhum campo extra. Clique em Adicionar se quiser enviar dados além de nome, telefone e e-mail.
        </p>
      )}

      {rows.map((row) => (
        <div key={row.id} className="grid gap-2 sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] items-end">
          <div className="space-y-1.5">
            <Label className="text-[12px] text-muted-foreground">Chave</Label>
            <Input
              value={row.key}
              onChange={(e) => onChange(rows.map((r) => (r.id === row.id ? { ...r, key: e.target.value } : r)))}
              onBlur={() => {
                const slug = slugifyCustomFieldKey(row.key);
                if (slug !== row.key) {
                  onChange(rows.map((r) => (r.id === row.id ? { ...r, key: slug } : r)));
                }
              }}
              placeholder="utm_source"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[12px] text-muted-foreground">Valor</Label>
            <Input
              value={row.value}
              onChange={(e) => onChange(rows.map((r) => (r.id === row.id ? { ...r, value: e.target.value } : r)))}
              placeholder="google"
            />
          </div>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className="h-10 px-2 text-destructive hover:text-destructive"
            onClick={() => onChange(rows.filter((r) => r.id !== row.id))}
          >
            <Trash2 className="h-4 w-4" />
            <span className="sr-only">Remover campo</span>
          </Button>
        </div>
      ))}
    </div>
  );
}
